/**
 * Renders the Bifrost Detail Component.
 *
 * @param {Object} chosenOrg - The chosen organization object.
 * @returns {JSX.Element} The rendered Bifrost Detail Component.
 */
import { useAuth0 } from "@auth0/auth0-react"
import React from "react"
import { Grid } from "semantic-ui-react"
import { isSuperAdminOrResellerAdmin } from "../../../Utils/util"
import BifrostLastSessionComponent from "./BifrostLastSessionComponent"
import BifrostOrgFeaturesComponent from "./BifrostOrgFeaturesComponent"
import BifrostOrgPackageComponent from "./BifrostOrgPackageComponent"
import BifrostOrgStructureComponent from "./BifrostOrgStructureComponent"
import BifrostOrgUserLimitComponent from "./BifrostOrgUserLimitComponent"

const OrgDetailsComponent = ({ chosenOrg, refreshData, orgDetailsLoading }) => {
	const { user } = useAuth0()

	return (
		<>
			{chosenOrg.id && (
				<Grid>
					<Grid.Row>
						<Grid.Column width={!isSuperAdminOrResellerAdmin(user) || process.env.REACT_APP_SAML_ENABLED === "true" ? 16 : 10}>
							<BifrostLastSessionComponent chosenOrg={chosenOrg} />
						</Grid.Column>
						{isSuperAdminOrResellerAdmin(user) && process.env.REACT_APP_SAML_ENABLED !== "true" && (
							<>
								<Grid.Column width={3}>
									<BifrostOrgPackageComponent chosenOrg={chosenOrg} refreshData={refreshData} orgDetailsLoading={orgDetailsLoading} />
								</Grid.Column>
								<Grid.Column width={3}>
									<BifrostOrgUserLimitComponent chosenOrg={chosenOrg} refreshData={refreshData} orgDetailsLoading={orgDetailsLoading} />
								</Grid.Column>
							</>
						)}
					</Grid.Row>
				</Grid>
			)}
			<Grid>
				<Grid.Row>
					<Grid.Column width={chosenOrg.id && isSuperAdminOrResellerAdmin(user) ? 10 : 16}>
						<BifrostOrgStructureComponent chosenOrg={chosenOrg} />
					</Grid.Column>
					{chosenOrg.id && isSuperAdminOrResellerAdmin(user) && (
						<Grid.Column width={6}>
							<BifrostOrgFeaturesComponent chosenOrg={chosenOrg} refreshData={refreshData} orgDetailsLoading={orgDetailsLoading} />
						</Grid.Column>
					)}
				</Grid.Row>
			</Grid>
		</>
	)
}

export default OrgDetailsComponent
